module.exports = __webpack_public_path__ + "static/media/logo@3x.83acf5f5.png";